import React, { forwardRef } from 'react'
import clsx from 'clsx'
import { useTheme } from '@ow/theme'
import StyledPopup from '../modal/styled/popup'

const Popup = forwardRef(
  (
    {
      width,
      contentStyle,
      content: Content,
      children,
      className,
      ...restProps
    },
    ref
  ) => {
    const { themeClass } = useTheme()
    return (
      <StyledPopup
        ref={ref}
        {...restProps}
        contentStyle={{
          // width: width || '800px',
          borderRadius: '5px',
          boxShadow:
            '0px 0px 1px 0px rgb(82 100 132 / 20%), 0px 8px 15.52px 0.48px rgb(28 43 70 / 15%)',
          borderWidth: '0',
          display: 'flex',
          flexDirection: 'column',
          backgroundClip: 'padding-box',
          border: '0 solid rgba(0,0,0,0)',
          outline: 0,
          ...contentStyle,
        }}
      >
        {(close) => (
          <div className={clsx(themeClass, className)}>
            {Content ? <Content close={close} /> : children}
          </div>
        )}
      </StyledPopup>
    )
  }
)

export default Popup
